var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:position-bottom-left-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.29167 17.7083H14.5833C14.8785 17.7083 15.126 17.6083 15.326 17.4083C15.526 17.2083 15.6257 16.9611 15.625 16.6667V15.625C15.625 15.3299 15.525 15.0823 15.325 14.8823C15.125 14.6823 14.8778 14.5826 14.5833 14.5833H7.29167C6.99653 14.5833 6.74896 14.6833 6.54896 14.8833C6.34896 15.0833 6.24931 15.3306 6.25 15.625V16.6667C6.25 16.9618 6.35 17.2094 6.55 17.4094C6.75 17.6094 6.99722 17.709 7.29167 17.7083ZM5.20833 21.875C4.63542 21.875 4.14479 21.6708 3.73646 21.2625C3.32813 20.8542 3.12431 20.3639 3.125 19.7917V5.20833C3.125 4.63542 3.32917 4.14479 3.7375 3.73646C4.14584 3.32813 4.63611 3.12431 5.20833 3.125H19.7917C20.3646 3.125 20.8552 3.32917 21.2635 3.7375C21.6719 4.14584 21.8757 4.63611 21.875 5.20833V19.7917C21.875 20.3646 21.6708 20.8552 21.2625 21.2635C20.8542 21.6719 20.3639 21.8757 19.7917 21.875H5.20833Z",
    fill: "#545454"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.0785015a666196ee933f56e8d00735d7.svg";
export { ForwardRef as ReactComponent };